
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";
import { AppointmentResult } from "./types";

export async function archiveAppointment(appointmentId: string): Promise<AppointmentResult> {
  try {
    const { data, error } = await supabase
      .from("appointments")
      .update({ archived: true })
      .eq("id", appointmentId)
      .select();

    if (error) {
      toast({
        title: "Erro ao arquivar compromisso",
        description: error.message,
        variant: "destructive",
      });
      return { success: false, error };
    }

    toast({
      title: "Compromisso arquivado com sucesso!",
      description: "O compromisso foi arquivado.",
    });
    return { success: true, data };
  } catch (error: any) {
    toast({
      title: "Erro ao arquivar compromisso",
      description: error.message,
      variant: "destructive",
    });
    return { success: false, error };
  }
}
